<template>
  <div class="leagues">
    <v-container class="leagues_wrapper">
      <v-row>
        <v-col cols="5" class="leagues_block">
          <smooth-scrollbar>
            <div class="leagues_wrapper">
              <v-dialog
                v-model="addNewLeagueDialog"
                persistent
                :retain-focus="false"
                max-width="600px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    class="leagues_add-btn"
                    color="#58a5f0"
                    @mouseenter="addBtnText = 'Add new league'"
                    @mouseleave="addBtnText = 'fa-plus'"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon v-if="addBtnText === 'fa-plus'">
                      {{ addBtnText }}
                    </v-icon>
                    <h3 v-else class="m-0 p-0">
                      {{ addBtnText }}
                    </h3>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Add new League</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="validation"
                        v-model="formValid"
                        lazy-validation
                      >
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="League name*"
                              v-model.trim="addNewLeagueData.name"
                              required
                              :counter="40"
                              :rules="nameRules"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-select
                              v-model.trim="addNewLeagueData.sport"
                              :items="sportTypes"
                              label="Sport type*"
                              hint="Swimming"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="Website*"
                              v-model.trim="addNewLeagueData.website"
                              hint="http,https://domain.com"
                              persistent-hint
                              required
                              :rules="websiteRules"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="League logo path*"
                              v-model.trim="addNewLeagueData.logo"
                              required
                              :rules="logoRules"
                              hint="/isl_league_logo.png"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="Description*"
                              v-model.trim="addNewLeagueData.description"
                              required
                              :counter="300"
                              :rules="descriptionRules"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <div class="rank_wrapper">
                              <v-checkbox
                                label="Ranks Clasifications"
                              ></v-checkbox>
                              <v-select
                                style="max-width: 250px"
                                :items="ranksClasifications"
                                item-text="node"
                                item-value="node"
                              >
                              </v-select>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    <small>*indicates required field</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeAddNewLeagueDialog()"
                    >
                      Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="addNewLeague()">
                      Add
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-col cols="12" v-if="!hasLeagues" class="leagues_warning">
                <v-alert
                  text
                  outlined
                  color="#004c8c"
                  icon="fa-exclamation-triangle"
                >
                  At the moment, the league list is empty. To add a new league,
                  click on the button above.
                </v-alert>
              </v-col>
              <v-col
                cols="12"
                v-for="league in getLeagues"
                :key="league.node.seqno"
                class="league"
                @click="changeLeague(league.node.name)"
                :style="[
                  league.node.name === leagueName
                    ? { border: '3px solid #004c8c' }
                    : { border: 'none' },
                ]"
              >
                <v-card color="#ffffff" hover>
                  <v-row>
                    <v-col cols="3" class="league_logo">
                      <!--In the future when we will get current img for all logos we need to pase here their src-->
                      <v-img src="/og_logo.png" contain></v-img>
                    </v-col>
                    <v-col cols="7" class="league_info">
                      <v-card-title>
                        {{ league.node.name }}
                      </v-card-title>
                      <v-card-subtitle>
                        {{ league.node.website }}
                      </v-card-subtitle>
                      <v-card-text>
                        {{ league.node.description }}
                      </v-card-text>
                    </v-col>
                    <v-col cols="2" class="league_btns">
                      <!-- dialogLeagueDelete -->
                      <button
                        class="league_btn league_btn-delete"
                        @click="deleteCurrentLeague(league.node)"
                      >
                        <v-icon> fa-trash </v-icon>
                      </button>
                      <button
                        class="league_btn league_btn-update"
                        @click="openUpdateLeagueDialog(league.node)"
                      >
                        <v-icon> fa-pen </v-icon>
                      </button>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-skeleton-loader
                type="list-item-avatar-three-line, actions"
                v-if="addLeagueLoader"
              ></v-skeleton-loader>
              <v-dialog
                v-model="updateLeagueDialog"
                persistent
                :retain-focus="false"
                max-width="600px"
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">
                      Update {{ addNewLeagueData.name }} league
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="validation"
                        v-model="formValid"
                        lazy-validation
                      >
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="League name*"
                              v-model="addNewLeagueData.name"
                              required
                              :counter="40"
                              :rules="nameRules"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-select
                              v-model="addNewLeagueData.sport"
                              :items="sportTypes"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="Website*"
                              v-model="addNewLeagueData.website"
                              hint="http,https://domain.com"
                              persistent-hint
                              required
                              :rules="websiteRules"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="League logo path*"
                              v-model="addNewLeagueData.logo"
                              required
                              :rules="logoRules"
                              hint="/isl_league_logo.png"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="Description*"
                              v-model="addNewLeagueData.description"
                              required
                              :counter="300"
                              :rules="descriptionRules"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <div class="rank_wrapper">
                              <v-checkbox
                              v-model="rankClasChecked"
                                label="Ranks Clasifications"
                              ></v-checkbox>
                              <v-select
                                style="max-width: 250px"
                                :items="ranksClasifications"
                                v-model="paramsToAdd"
                                item-text="node"
                                item-value="node"
                              >
                              </v-select>
                            </div>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    <small>*indicates required field</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeUpdateLeagueDialog()"
                    >
                      Close
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="updateCurrentLeague()"
                    >
                      Update
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </smooth-scrollbar>
        </v-col>
        <v-col cols="7">
          <v-data-table
            :headers="headers"
            :items="this.allClub"
            :loading="loadingTable"
            :items-per-page="20"
            loading-text="Loading... Please wait"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{ getLeagueName }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="addClubDialog"
                  :retain-focus="false"
                  max-width="500px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on">
                      Add club
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="10" style="text-align: center">
                            <v-menu
                              bottom
                              auto
                              origin="center center"
                              transition="scale-transition"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  dark
                                  v-bind="attrs"
                                  v-on="on"
                                  style="width: 100% !important"
                                >
                                  {{ clubToAdd }}
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item
                                  v-for="club in clubs"
                                  :key="club.node.clubId"
                                  @click="clubToAdd = club.node.clubName"
                                >
                                  <v-list-item-title>{{
                                    club.node.clubName
                                  }}</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="addClubToLeague"
                      >
                        Add
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-icon small @click="deleteClub(item)"> fa-trash </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert
                v-if="!hasLeagues"
                text
                outlined
                color="#004c8c"
                style="margin-top: 16px"
                icon="fa-exclamation-triangle"
              >
                At the moment you have no leagues, add a new league to be able
                to manage its clubs
              </v-alert>
              <v-alert
                v-else
                text
                outlined
                color="#004c8c"
                style="margin-top: 16px"
                icon="fa-exclamation-triangle"
              >
                {{ leagueName }} league has no clubs
              </v-alert>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="getSnackbarState"
      class="hidden-xs-only p-10"
      :color="snackbarColor"
      bottom
      right
    >
      <v-row justify="center" align="center">
        <h3 class="p-0 m-0" style="color: black">{{ getSnackbarText }}</h3>
      </v-row>
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable prettier/prettier */
import { mapGetters, mapActions, mapMutations } from "vuex";
import { clubsTableHeader, validationRules } from "../../../constants/global";
// import { hasItem } from "../../_helpers/index";
export default {
  data() {
    return {
      headers: clubsTableHeader,
      leagueName: "",
      loadingTable: true,
      addClubDialog: false,
      formValid: true,
      updatedLeagueSeqno: 0,
      editedIndex: -1,
      dialogClubDelete: false,
      updateLeagueDialog: false,
      clubToAdd: "Select the club",
      addBtnText: "fa-plus",
      addNewLeagueDialog: false,
      addLeagueLoader: false,
      paramsToAdd:null,
      rankClasChecked:false,
      sportTypes: ["Swimming", "Basketball", "Football"],
      addNewLeagueData: {
        name: "",
        sport: "Swimming",
        logo: "",
        website: "",
        description: "",
        updateSource: "test data",
        params: [],
      },
      addNewLeagueDefaultData: {
        name: "",
        sport: "Swimming",
        logo: "",
        website: "",
        description: "",
        updateSource: "test data",
        params: [],
      },
      allClub: [],
      nameRules: validationRules.name,
      typeRules: validationRules.type,
      logoRules: validationRules.logo,
      websiteRules: validationRules.website,
      descriptionRules: validationRules.description,
      ranks: [],
    };
  },
  async created() {
    await this.getAllLeagues();
    await this.allClubs();
    await this.getLeaguesAttitude().then(() => {
      this.leagueName = this.getFirstLeague;
    });
    this.allClub = this.getAllRelatedClubs(
      this.getCurrentLeagueSeqno(this.leagueName)
    );

    this.loadingTable = false;
  },
  computed: {
    ...mapGetters([
      "getLeagues",
      "clubs",
      "leaguesAttitude",
      "getSnackbarState",
      "getSnackbarText",
      "categoryValue",
      "categoryList",
    ]),
    getFirstLeague() {
      console.log(this.getLeagues, "getLeagues");
      return this.getLeagues[0].node.name || "No league";
    },
    formTitle() {
      switch (this.editedIndex) {
        case -1:
          return "Add new club";
        case 1:
          return "Delete club";
        default:
          return "You really want to do it ?";
      }
    },
    ranksClasifications() {
      if (this.categoryValue.edges && this.categoryList.edges) {
        this.categoryValue.edges.filter((item) => {
          if (item.node.category.catName === "RANK_CLASS") {
            this.ranks.push({ node: item.node.valName, selected: false });
          }
        });
        return this.ranks;
      } else {
        return [];
      }
    },
    hasLeagues() {
      return this.getLeagues.length > 0;
    },
    getLastLeagueSeqno() {
      if (this.hasLeagues) {
        return parseInt(
          this.getLeagues[this.getLeagues.length - 1].node.seqno,
          10
        );
      } else {
        return 0;
      }
    },
    getLastRelationSeqno() {
      if (this.leaguesAttitude.length > 0) {
        return parseInt(
          this.leaguesAttitude[this.leaguesAttitude.length - 1].node.seqno,
          10
        );
      } else {
        return 0;
      }
    },
    snackbarColor() {
      if (this.getSnackbarText.includes("added")) {
        return "#60ad5e";
      } else if (this.getSnackbarText.includes("updated")) {
        return "#ffd95a";
      } else if (this.getSnackbarText.includes("deleted")) {
        return "#ff5f52";
      } else {
        return "#ffd95a";
      }
    },
    getLeagueName() {
      return this.hasLeagues ? this.leagueName : "No League";
    },
  },
  methods: {
    ...mapActions([
      "getAllLeagues",
      "allClubs",
      "getLeaguesAttitude",
      "deleteLeagueClubRel",
      "createRelationshipToLeague",
      "deleteLeague",
      "createLeague",
      "updateLeague",
    ]),
    checkboxChange(elem) {
      console.log(elem);
      console.log(document.getElementById(elem.node));
    },
    ...mapMutations(["showSnackbar", "hiddeSnackbar", "setSnackbarText"]),
    /**
     * @param {Object} league.node
     * @return {Array <int>}
     */
    getIdsRelatedClubs(league) {
      return this.leaguesAttitude
        .filter((item) => item.node.leagueSeqno === +league.seqno)
        .map((club) => club.node.clubId);
    },
    /**
     * @param {Number} ids
     * @return {Object} club info
     */
    getFullClubInfoById(id) {
      if (this.clubs) {
        return this.clubs.filter((club) => +club.node.clubId === +id)[0].node;
      }
    },
    /**
     * @return {Boolean}
     */
    validateForm() {
      return this.$refs.validation.validate();
    },
    showInfo() {
      console.log(this.$route);
    },
    changeLeague(league_name) {
      this.leagueName = league_name;
      this.allClub = this.getAllRelatedClubs(
        this.getCurrentLeagueSeqno(this.leagueName)
      );
    },
    getAllRelatedClubs(league_seqno) {
      const clubs = this.leaguesAttitude.filter(
        (el) => el.node.leagueSeqno === league_seqno
      );
      return clubs
        .map((club) => this.getFullClubInfoById(club.node.clubId))
        .map((el) => {
          const { clubDesc, clubName, team, year } = el;
          return {
            club_name: clubName,
            club_description: clubDesc,
            teams_quantity: team.edges.length,
            foundation_time: year,
          };
        });
    },
    close() {
      this.addClubDialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.clubToAdd = "Select the club";
      });
    },
    /**
     * @param {Object} club
     */
    deleteClub(club) {
      this.loadingTable = true;
      this.editedIndex = 1;
      this.setupClubsToDelete(
        this.getCurrentClubId(club.club_name),
        this.getCurrentLeagueSeqno(this.leagueName)
      ).map((el) =>
        this.deleteLeagueClubRel({ seqno: +el.node.seqno })
          .then(() => {
            this.loadingTable = false;
            this.allClub = this.getAllRelatedClubs(
              this.getCurrentLeagueSeqno(this.leagueName)
            );
          })
          .catch(() => (this.loadingTable = false))
      );
    },
    /**
     * @param {String} league_name
     * @return {number} seqno [Must be int in more cases]
     */
    getCurrentLeagueSeqno(league_name) {
      return (
        +this.getLeagues.filter((el) => el.node.name === league_name)[0].node
          .seqno || 0
      );
    },
    /**
     * @param {String} club_name
     * @return {Int} clubId
     */
    getCurrentClubId(club_name) {
      return this.clubs.filter((club) => club.node.clubName === club_name)[0]
        .node.clubId;
    },
    /**
     * @param {Int} club_id
     * @param {String} league_seqno
     * @return {Array<Objects>}
     */
    setupClubsToDelete(club_id, league_seqno) {
      return this.leaguesAttitude.filter(
        (el) =>
          +el.node.clubId === parseInt(club_id, 10) &&
          +el.node.leagueSeqno === parseInt(league_seqno, 10)
      );
    },
    addClubToLeague() {
      this.loadingTable = true;
      const relationSeqno = this.getLastRelationSeqno;
      const leagueSeqno = parseInt(
        this.getCurrentLeagueSeqno(this.leagueName),
        10
      );
      const clubId = parseInt(
        this.clubs.filter((c) => c.node.clubName === this.clubToAdd)[0].node
          .clubId,
        10
      );

      this.createRelationshipToLeague({
        seqno: relationSeqno + 1,
        league_seqno: leagueSeqno,
        club_id: clubId,
      })
        .then(() => {
          this.loadingTable = false;
          this.allClub = this.getAllRelatedClubs(
            this.getCurrentLeagueSeqno(this.leagueName)
          );
        })
        .catch(() => (this.loadingTable = false));
      this.close();
    },
    /**
     * @param {Object} league
     */
    deleteCurrentLeague(league) {
      const clubs = [];
      this.getIdsRelatedClubs(league).map((related_club_id) => {
        this.setupClubsToDelete(related_club_id, league.seqno).map((el) => {
          clubs.push(this.deleteLeagueClubRel({ seqno: +el.node.seqno }));
        });
      });

      Promise.all(clubs).then(() => {
        this.deleteLeague({ seqno: parseInt(league.seqno, 10) })
          .then(() => {
            this.$toast.error(`League ${this.leagueName} was deleted`);
            this.leagueName =
              this.getLeagues[this.getLeagues.length - 1].node.name;
            this.allClub = this.getAllRelatedClubs(
              this.getCurrentLeagueSeqno(this.leagueName)
            );
          })
          .catch(() => this.$toast.error("Something went wrong("));
      });
    },
    async addNewLeague() {
      this.addLeagueLoader = true;
      let hasLeague = this.hasLeagues
        ? this.getLeagues.filter(
            (l) => l.node.name === this.addNewLeagueData.name
          ).length > 0
        : true;
      if (!hasLeague) {
        if (this.validateForm()) {
          this.addNewLeagueDialog = false;
          await this.createLeague({
            seqno: this.getLastLeagueSeqno + 1,
            name: this.addNewLeagueData.name,
            description: this.addNewLeagueData.description,
            logo: this.addNewLeagueData.logo,
            sport: this.addNewLeagueData.sport,
            website: this.addNewLeagueData.website,
            updateSource: this.addNewLeagueData.updateSource,
            params:this.paramsToAdd
          })
            .then(() => {
              this.addLeagueLoader = false;
              this.leagueName = this.addNewLeagueData.name;
              this.allClub = this.getAllRelatedClubs(
                this.getCurrentLeagueSeqno(this.leagueName)
              );
              this.$toast.success(`League ${this.leagueName} was added`);
            })
            .catch(() => (this.addLeagueLoader = false));
          this.addNewLeagueData = Object.assign(
            {},
            this.addNewLeagueDefaultData
          );
        }
      } else {
        this.$toast.warning("League with this name alredy exist");
      }
    },
    closeAddNewLeagueDialog() {
      this.addLeagueLoader = false;
      this.addNewLeagueDialog = false;
      this.addNewLeagueData = Object.assign({}, this.addNewLeagueDefaultData);
    },
    closeUpdateLeagueDialog() {
      this.updateLeagueDialog = false;
      this.addNewLeagueData = Object.assign({}, this.addNewLeagueDefaultData);
    },
    async updateCurrentLeague() {
      if (this.validateForm()) {
        console.log(this.paramsToAdd, "this.updatedLeagueSeqno");
        await this.updateLeague({
          seqno: this.updatedLeagueSeqno,
          name: this.addNewLeagueData.name,
          description: this.addNewLeagueData.description,
          logo: this.addNewLeagueData.logo,
          sport: this.addNewLeagueData.sport,
          website: this.addNewLeagueData.website,
          updateSource: "test data",
           params: JSON.stringify({'rank_classification':this.paramsToAdd}) 
        })
          .then(() => {
            this.leagueName = this.addNewLeagueData.name;
            this.allClub = this.getAllRelatedClubs(
              this.getCurrentLeagueSeqno(this.leagueName)
            );
            this.$toast.info(`League ${this.leagueName} was updated`);
          })
          .catch((error) => {
            console.log(error);
          });
        this.addNewLeagueData = Object.assign({}, this.addNewLeagueDefaultData);
        this.updateLeagueDialog = false;
      }
    },
    /**
     * @param {Object} league
     */
    openUpdateLeagueDialog(league) {
      this.updateLeagueLoader = true;
      const { name, sport, logo, website, description } = league;
      const arrayToReplace = [name, sport, logo, website, description];
      Object.keys(this.addNewLeagueData).forEach(
        (item, index) => (this.addNewLeagueData[item] = arrayToReplace[index])
      );
     
      this.paramsToAdd = JSON.parse(league.params).rank_class;
       if(this.paramsToAdd != null ||this.paramsToAdd != undefined){
        this.rankClasChecked = true;
       }
      this.updatedLeagueSeqno = parseInt(league.seqno, 10);
      this.updateLeagueDialog = true;
    },
  },
};
</script>
<style lang="scss">
.leagues {
  height: 90vh;

  &_block {
    max-height: 90vh;
  }

  &_add-btn {
    margin-bottom: 10px;
    text-align: center;
    transition: all 0.3s;
  }

  &_add-btn:hover {
    background-color: #85bb5c !important;
    box-shadow: 0 0 7px #85bb5c !important;
  }
}

.league {
  transition: ease-out 0.1s;
  margin-bottom: 10px;

  &_logo {
    background-color: #58a5f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &_btns {
    height: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-left: 1px solid gray;
    padding: 0 !important;
  }

  &_btn {
    width: 100%;
    height: (100% / 2);
  }

  &_btn-delete {
    background-color: #58a5f0;
    border-bottom: 1px solid #ffffff;
    transition: all 0.3s;
  }

  &_btn-delete:hover {
    background-color: #f44336;
    box-shadow: 0 0 7px #f44336;
  }

  &_btn-update {
    background-color: #58a5f0;
    transition: all 0.3s;
  }

  &_btn-update:hover {
    background-color: #ffc107;
    box-shadow: 0 0 7px #ffc107;
  }
}
.rank_wrapper {
  flex-direction: row;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
</style>
